import React,{useEffect}  from 'react';
import {connect} from 'react-redux';
import { initiate, setNextWizardStep } from '../../routerActivationWizardBlockSlice';
import BtnSubmit  from '../../../../Shared/Buttons/BtnSubmit';
import LocalLoader from '../../../../Shared/LocalLoader/LocalLoader';
import gaParams from '../../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../../utilities/analytics/tracking';
import './ReadyStep.scss';

const ReadyStep = (props) => {

   useEffect(()=>{
    if (props.RequestId === ''){
      gaEvent(gaParams.ROUTER_ACTIVATION_WIZARD_READY_STEP_PHASE_1_DISPLAY.category, 
        gaParams.ROUTER_ACTIVATION_WIZARD_READY_STEP_PHASE_1_DISPLAY.eventType, 
        gaParams.ROUTER_ACTIVATION_WIZARD_READY_STEP_PHASE_1_DISPLAY.eventParams);
    }
    else{
      gaEvent(gaParams.ROUTER_ACTIVATION_WIZARD_READY_STEP_PHASE_2_DISPLAY.category, 
        gaParams.ROUTER_ACTIVATION_WIZARD_READY_STEP_PHASE_2_DISPLAY.eventType, 
        gaParams.ROUTER_ACTIVATION_WIZARD_READY_STEP_PHASE_2_DISPLAY.eventParams);
    }
   },[props.RequestId]);

   async function setNextStep() {

    gaEvent(gaParams.ROUTER_ACTIVATION_WIZARD_READY_STEP_PHASE_2_CLICK_LETS_GO_BUTTON.category, 
      gaParams.ROUTER_ACTIVATION_WIZARD_READY_STEP_PHASE_2_CLICK_LETS_GO_BUTTON.eventType, 
      gaParams.ROUTER_ACTIVATION_WIZARD_READY_STEP_PHASE_2_CLICK_LETS_GO_BUTTON.eventParams);

    var obj={
      RequestId: props.RequestId,
      Step: props.Step,
      CurrentStep: props.CurrentStep
    };
    await props.setNextWizardStep(obj);
  }

  return(<div className='ready-step' style={{height:'235px !important'}}>
              <div className='ready-step-title'>תתחדשו על הסופר ראוטר!</div>
              {props.RequestId && props.RequestId != ''  ? 
                <div>
                    <div className='ready-step-text'>התקנה מהירה ב-3 שלבים ואנחנו כאן כדי ללוות אתכם :)</div>
                    <div className='ready-step-button'><BtnSubmit text='בואו נעשה את זה' onclick={setNextStep} formid=''/></div>
                </div>:
                <div className='ready-step-text' >
                  <div style={{margin:'40px auto'}}>מוכנים להתחבר?</div>
                  <div ><LocalLoader/></div>
                </div>}                                    
        </div>);
};

const mapStateToProps = (state) => {
    return {
      RequestId: state.RouterActivationWizardBlock.wizardRequestId,
      CurrentStep: state.RouterActivationWizardBlock.currentStep,
      Step: state.RouterActivationWizardBlock.step
    };
};

const mapDispatchToProps = {
  initiate,
  setNextWizardStep
};

export default connect(mapStateToProps,mapDispatchToProps)(ReadyStep);